import React from 'react';
import { connect } from 'dva';
import { templateConfig, reduxTemplateCofig } from './config'

import { framework_tool } from '@/tool'
let { WizContainer, WizReduxTemplate } = framework_tool;
class WorkflowAudit extends WizContainer {

  componentName = 'Audit';

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }


  _render() {
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: templateConfig({dispatch:this.dispatch}),
      apiDataFormat: {
        delete: this._handleCMD,
      },
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(WorkflowAudit);
